import Vue from "vue";

/**
 *
 * @param error Information about the error
 * @param error.status The error status
 * @param error.data The error data
 * @param data
 */
export function showHttpErrorMessage({ status, data })
{
  let messages = [];
  let errors;

  if (typeof data === 'object' && data !== null && !data.errors && status === 422) {
    errors = [];
    for (const [key, value] of Object.entries(data)) {
      if (key === 'status') {
        continue;
      }
      if (typeof value === 'string') {
        errors.push(value);
      } else {
        errors.push(value[0]);
      }
    }
  } else if (typeof data !== 'undefined' && data.errors) {
    errors = data.errors;
  } else if (status === 403) {
    errors = ['Sem permissão de acesso!'];
  } else {
    errors = ['Ocorreu um erro'];
  }

  for (const key in errors) {
    messages.push(errors[key]);
  }

  // https://github.com/shakee93/vue-toasted
  Vue.toasted.show(messages[0], {
    type: 'error',
    position: "top-center",
    keepOnHover: true,
    duration: 5000,
  });
}

/**
 * Get query strings from url
 *
 * @returns {{}}
 */
export function getUrlParams()
{
  return window.location.search.slice(1).split('&').reduce((accumulator, item) => {
    if (item) {
      accumulator[item.split('=')[0]] = item.split('=')[1];
    }
    return accumulator;
  }, {})
}

/**
 * Retorna o valor de um parâmetro da url
 *
 * @param {string} key
 */
export function getUrlParam(key)
{
  return getUrlParams()[key];
}

/**
 * Altera o valor de um parâmetro da url
 *
 * @param {string} key
 * @param {string} value
 */
export function setUrlParam(key, value)
{
  let url = new URL(window.location.href);
  if (value === null || value === undefined || value === '') {
    url.searchParams.delete(key)
  } else {
    url.searchParams.set(key, value);
  }
  window.history.pushState("", "", url.href);
}

/**
 * Altera o valor de todos os parâmetros da url contidos em um objeto
 *
 * @param {object} params
 */
export function setUrlParams(params)
{
  let url = new URL(window.location.href);
  for (const key in params) {
    if (params[key]) {
      url.searchParams.set(key, params[key]);
    } else {
      url.searchParams.delete(key)
    }
  }
  window.history.pushState("", "", url.href);
}

/**
 * Convert object as url query string
 * @deprecated Use urlParamsToQueryString
 *
 * @param {object} urlParams
 * @returns {*}
 */
export function objectAsQueryString(urlParams)
{
  return urlParamsToQueryString(urlParams)
}

/**
 * Convert object as url query string
 *
 * @param {object} urlParams
 * @returns {*}
 */
export function urlParamsToQueryString(urlParams)
{
  return Object.keys(urlParams).reduce((acc, cur, index, src) => {
    const url = `${acc}${cur}=${urlParams[cur]}`;
    return index !== src.length -1
      ? `${url}&`
      : url
  }, '?');
}

/**
 * Exibe uma notificação toast usando Vue.toasted
 *
 * @param {string} message
 * @param {object} options
 * @returns {*}
 */
export function showToast(message, options = {}) {
  Vue.toasted.show(message, {
    type: 'success',
    position: "top-center",
    keepOnHover: true,
    duration: 5000,
    ...options
  });
}
